import {
  ADD_USER_BALANCE,
  ADD_USER_BALANCE_SUCCESS,
  ADD_USER_BALANCE_FAILURE,
} from "../actionTypes";

export const addUserBalance = (payload) => ({
  type: ADD_USER_BALANCE,
  payload,
});

export const addUserBalanceSuccess = (payload) => ({
  type: ADD_USER_BALANCE_SUCCESS,
  payload,
});

export const addUserBalanceFailure = () => ({
  type: ADD_USER_BALANCE_FAILURE,
});